<template>
	<BasicLayout>
		<el-row>
			<el-col :xs='{span: 22, offset: 1}' :sm='{span: 18, offset: 3}' :md='{span: 16, offset: 4}' :lg='{span: 14, offset: 5}'>
				
				<el-card v-loading="loading">
					<div slot="header" class="clearfix">
						<h1><i class="fas fa-lg fa-fw fa-chart-pie"></i> Paramètres statistiques</h1>
					</div>

					<el-form ref="statsForm" :model="settings" :rules="rules" label-width="195px">
							
						<el-form-item label="Heure début de journée" prop="dayStartTime">
							<el-input type="time" v-model="settings.dayStartTime"></el-input>
						</el-form-item>

						<div style="text-align: center;">
							<el-button icon="fas fa-times" @click="back"> Annuler</el-button>
							<el-button icon="fas fa-save" @click="submit" type="primary" :disabled="submited"> Enregistrer</el-button>
						</div>
					</el-form>
				</el-card>

			</el-col>
		</el-row>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import StatsService from '@/services/stats.service'

export default {
	name: 'stats-settings',
	components: { BasicLayout },
	data: function () {
		return {
			loading: true,
			submited: false,
			settings: { },
        	rules: {
				dayStartTime: [ { required: true, message: 'Veuillez saisir l\'heure de début de journée', trigger: 'blur' } ]
			}
		}
	},
	methods: {
		submit() {
			// Valide le formulaire
			this.$refs['statsForm'].validate((valid) => {
				if (valid) {

					// Affiche le loader
					this.loading = true

					// Enregistrement
					StatsService.saveSettings(this.settings).then((result) => {

						// Retour liste
						this.$router.push('/stats')
					})

				} else {
					return false;
				}
			});
		},
		back() {
			// Retour aus stats
			this.$router.push('/stats')
		}
	},
	mounted: function() {

		// Récupère les parametres
		StatsService.getSettings().then((settings) => {

			this.settings = settings
			this.loading = false
		})
	}
}
</script>
